import { ObjectSchemaType } from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import { IUpdateDepartmentProcessItem } from "mobx-stores/_models/work-order/work-order-item";
import { date, number } from "yup";

export const getUpdateDepartmentProcessFormSchema =
  (): ObjectSchemaType<IUpdateDepartmentProcessItem> => ({
    type: {
      type: InputType.none,
    },
    date: {
      gridSize: 12,
      label: "Ngày",
      type: InputType.datePicker,
      validattionYupSchema: date().required(),
    },
    amount: {
      gridSize: 12,
      label: "Số lượng",
      type: InputType.number,
      validattionYupSchema: number().required(),
    },
  });
